import React, { useState, useEffect } from "react";
import backgroundImage from "../../app/assets/videos/backgroundImage.png";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
} from "@azure/msal-react";
import Login from "../../app/auth/Login";
import Header from "../../app/nav/Header";

const Overview = () => {
  const [showMultiple, setShowMultiple] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => setShowMultiple(true), 2000);
    return () => clearTimeout(timer);
  }, []);

  const goToApp = () => {
    navigate("/application");
  };

  return (
    <>
      <AuthenticatedTemplate>
        <div className="min-h-screen flex flex-col">
          <Header />

          <div
            className="flex-1 w-full flex items-center justify-center bg-cover bg-center"
            style={{ backgroundImage: `url(${backgroundImage})` }}
          >
            <div className="text-center px-6 max-w-4xl">
              <motion.h1
                className="text-white font-bold text-4xl md:text-5xl lg:text-6xl mb-6"
                key={showMultiple}
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ duration: 1 }}
              >
                {!showMultiple ? (
                  <>
                    One <span className="text-[#E12AFB]">Platform</span>
                  </>
                ) : (
                  <>
                    Multiple
                    <br />
                    <span className="text-[#E12AFB]">Powerful Applications</span>
                  </>
                )}
              </motion.h1>

              <p className="text-white text-base md:text-lg lg:text-xl leading-relaxed mb-8">
                Access all your essential tools from a single, unified dashboard.
                <br />
                Everything you need, right where you need it.
              </p>

              {showMultiple && (
                <motion.button
                  onClick={goToApp}
                  className="bg-[#E12AFB] hover:bg-purple-600 text-white font-semibold py-2 px-6 rounded-lg transition-all duration-300 shadow-lg"
                  initial={{ opacity: 0, scale: 0.7 }}
                  animate={{ opacity: 1, scale: 1 }}
                  transition={{ duration: 0.8, delay: 0.3 }}
                >
                  Go to Application
                </motion.button>
              )}
            </div>
          </div>
        </div>
      </AuthenticatedTemplate>

      <UnauthenticatedTemplate>
        <Login />
      </UnauthenticatedTemplate>
    </>
  );
};

export default Overview;